import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageNotFound from "./PageNotFound";
import NavBar from "./header/NavBar";
import ProtectedRoute from "./utils/ProtectedRoute";
import Menus from "./Menus";
import IMenu from "./components/pages/models/interfaces/IMenu";

function App() {
  let submenus: IMenu[] = [];
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NavBar />}>
          {
            Menus.map(({ id, secure, linkmenu, submenu, namesub, allowedRoles, component: Component }) => {
              if (submenu !== undefined) {
                namesub.map((submenu: IMenu) => {
                  submenus.push({
                    id: submenu.id,
                    secure: submenu.secure,
                    name: submenu.name,
                    linkmenu: submenu.linkmenu,
                    submenu: submenu.submenu,
                    allowedRoles: submenu.allowedRoles,
                    component: submenu.component,
                    defaultSubmenuId: 0,
                    namesub: submenu.namesub,
                    show: submenu.show
                  });
                });
              }
              if (secure)
                return (<Route key={id} path={linkmenu} element={<ProtectedRoute component={<Component />} roles={allowedRoles} />} />)
              return (<Route key={id} path={linkmenu} element={<Component />} />)
            })
          }
          {
            submenus.map(({ id, secure, linkmenu, allowedRoles, component: Component }) => {
              if (secure)
                return (<Route key={id} path={linkmenu} element={<ProtectedRoute component={<Component />} roles={allowedRoles} />} />)
              return (<Route key={id} path={linkmenu} element={<Component />} />)
            })
          }
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;